// extracted by mini-css-extract-plugin
export default {"root":"tGxNyoSd7EDNi8w3z8w0"};